import React from 'react';
import { Link } from 'react-router-dom';
import AppStoreBadges from './AppStoreBadges';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-xl font-bold text-white">
              Pickify<span className="text-orange-500">AI</span>
            </Link>
            <p className="mt-3 text-sm text-gray-400">
              AI-powered gift finder that helps you discover the perfect gift in 30 seconds. Free, personalized, no signup required.
            </p>
          </div>

          {/* Gift Ideas */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Gift Ideas</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/gifts/gifts-for-him" className="hover:text-white transition-colors">Gifts for Him</Link></li>
              <li><Link to="/gifts/gifts-for-her" className="hover:text-white transition-colors">Gifts for Her</Link></li>
              <li><Link to="/gifts/gifts-for-mom" className="hover:text-white transition-colors">Gifts for Mom</Link></li>
              <li><Link to="/gifts/gifts-for-dad" className="hover:text-white transition-colors">Gifts for Dad</Link></li>
              <li><Link to="/gifts/gifts-for-husband" className="hover:text-white transition-colors">Gifts for Husband</Link></li>
              <li><Link to="/gifts/gifts-for-boyfriend" className="hover:text-white transition-colors">Gifts for Boyfriend</Link></li>
              <li><Link to="/gifts/gifts-for-girlfriend" className="hover:text-white transition-colors">Gifts for Girlfriend</Link></li>
              <li><Link to="/gifts/gifts-under-50" className="hover:text-white transition-colors">Gifts Under $50</Link></li>
            </ul>
          </div>

          {/* By Occasion */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">By Occasion</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/gifts/birthday-gifts" className="hover:text-white transition-colors">Birthday Gifts</Link></li>
              <li><Link to="/gifts/christmas-gifts" className="hover:text-white transition-colors">Christmas Gifts</Link></li>
              <li><Link to="/gifts/anniversary-gifts" className="hover:text-white transition-colors">Anniversary Gifts</Link></li>
              <li><Link to="/gifts/wedding-gifts" className="hover:text-white transition-colors">Wedding Gifts</Link></li>
              <li><Link to="/gifts/graduation-gifts" className="hover:text-white transition-colors">Graduation Gifts</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">Gift Finder Quiz</Link></li>
              <li><Link to="/deals" className="hover:text-white transition-colors">Deals</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Gift Guides Blog</Link></li>
              <li><Link to="/reviews" className="hover:text-white transition-colors">Reviews</Link></li>
              <li><Link to="/ai-gift-finder" className="hover:text-white transition-colors">AI Gift Finder</Link></li>
              <li><Link to="/blog/best-ai-gift-finders-2026" className="hover:text-white transition-colors">AI Gift Finder Comparison</Link></li>
            </ul>
          </div>
        </div>

        {/* Get the App row */}
        <div className="border-t border-gray-800 mt-10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-center md:text-left">
              <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-1">Get the App</h3>
              <p className="text-sm text-gray-400">Save picks, get deal alerts, re-quiz on the go.</p>
            </div>
            <AppStoreBadges placement="footer" variant="both" height={44} />
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-8 pt-6 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Pickify. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
